import styled from 'styled-components';
import { mixins } from '../../css';

export const StyledButton = styled.button`
  font-family: inherit;
  font-size: inherit;
  padding: 0;
  color: inherit;
  text-transform: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  outline: none;
  background: transparent;
  cursor: pointer;
`;

export const ModalContent = styled.div`
  padding: ${mixins.pxToRem(74)} 0;
`;
